var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import { isEmpty } from 'lodash';
import { Icon } from "../../UI";
import { uploadDocument } from "../../Uploads/actions/uploadsActions";
import { wrapDispatch } from "../../Multireducer";
import { socket } from "../../socket";
import { Translate } from "../../I18N";

const renderProgress = (progress) => /*#__PURE__*/
_jsx("div", { className: "upload-button btn btn-default btn-disabled" }, void 0, /*#__PURE__*/
_jsx("span", {}, void 0, progress, "%"), "\xA0", /*#__PURE__*/

_jsx(Translate, {}, void 0, "Uploading")
);


const renderProcessing = () => /*#__PURE__*/
_jsx("div", { className: "upload-button btn btn-default" }, void 0, /*#__PURE__*/
_jsx(Icon, { icon: "cog", spin: true }), "\xA0", /*#__PURE__*/

_jsx(Translate, {}, void 0, "Processing")
);


class UploadButton extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      processing: false,
      failed: false,
      completed: false,
      entitySharedId: props.entitySharedId
    };
    this.conversionStart = this.conversionStart.bind(this);
    this.conversionFailed = this.conversionFailed.bind(this);
    this.documentProcessed = this.documentProcessed.bind(this);

    socket.on('conversionStart', this.conversionStart);
    socket.on('conversionFailed', this.conversionFailed);
    socket.on('documentProcessed', this.documentProcessed);

    this.onChange = this.onChange.bind(this);
  }

  componentWillUnmount() {
    socket.removeListener('conversionStart', this.conversionStart);
    socket.removeListener('conversionFailed', this.conversionFailed);
    socket.removeListener('documentProcessed', this.documentProcessed);
    clearTimeout(this.timeout);
  }

  static getDerivedStateFromProps(newProps, state) {
    if (newProps.entitySharedId !== state.entitySharedId) {
      return {
        processing: false,
        failed: false,
        completed: false,
        entitySharedId: newProps.entitySharedId
      };
    }

    return null;
  }

  onChange(e) {
    const file = e.target.files[0];
    this.props.uploadDocument(this.props.entitySharedId, file);
  }

  documentProcessed(docId) {
    if (docId === this.props.entitySharedId) {
      this.setState({ processing: false, failed: false, completed: true }, () => {
        this.timeout = setTimeout(() => {
          this.setState({ processing: false, failed: false, completed: false });
        }, 2000);
      });
    }
  }

  conversionStart(docId) {
    if (docId === this.props.entitySharedId) {
      this.setState({ processing: true, failed: false, completed: false });
    }
  }

  conversionFailed(docId) {
    if (docId === this.props.entitySharedId) {
      this.setState({ processing: false, failed: true, completed: false });
    }
  }

  renderButton(status = '', icon = 'plus', message = 'Add PDF') {
    return (/*#__PURE__*/
      _jsx("label", { htmlFor: "upload-button-input", className: `upload-button btn upload-${status}` }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: icon }), "\xA0", /*#__PURE__*/

      _jsx("input", {
        onChange: this.onChange,
        type: "file",
        accept: "application/pdf",
        id: "upload-button-input" }
      ), "\xA0", /*#__PURE__*/

      _jsx(Translate, {}, void 0, message)
      ));

  }

  render() {
    const progress = this.props.progress.get(this.props.entitySharedId);

    switch (true) {
      case this.state.failed:
        return this.renderButton('failed', 'exclamation-triangle', 'An error occurred');
      case this.state.processing || progress === 0:
        return renderProcessing();
      case progress > 0 && progress < 100:
        return renderProgress(progress);
      case this.state.completed || progress === 100:
        return this.renderButton('success', 'check', 'Success, Upload another?');

      default:
        return this.renderButton();
    }
  }
}

UploadButton.defaultProps = {
  progress: Immutable.fromJS({}),
  storeKey: '',
  entitySharedId: '',
  uploadDocument: () => {}
};








const mapStateToProps = ({ metadata, progress }) => ({
  progress: isEmpty(progress) ? metadata.progress : progress
});

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators({ uploadDocument }, wrapDispatch(dispatch, props.storeKey));
}

export { UploadButton };
export default connect(mapStateToProps, mapDispatchToProps)(UploadButton);